/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
export const ADD_KPI_DIALOG = 'Add function';
export const AVAILABLE_GRAINS_DIALOG = 'Available Grains Dialog';
export const REMOVE_GRAIN_DIALOG = 'Remove Grain Dialog';
export const REMOVE_KPI_DIALOG = 'Remove KPI Dialog';
export const DEPENDENCIES_DIALOG = 'Dependencies Dialog';
export const UPDATE_GRAIN_DIALOG = 'Update Grain Dialog';
export const ENTITY_TYPE_CONSTANT_DIALOG = 'Entity Type Constants Dialog';
export const ENTITY_TYPE_CONSTANT_EDIT_DIALOG = 'Entity Type Constants Edit Dialog';
export const ENTITY_TYPE_CONSTANT_REMOVE_DIALOG = 'Entity Type Constants Remove Dialog';
export const ENTITY_TYPE_CONSTANT_CONFIRM_DIALOG = 'Entity Type Constants Confirm Dialog';
export const ENTITY_TYPE_CONSTANT_REVERT_CONFIRM_DIALOG = 'Entity Type Revert Confirm Dialog';
export const VIEW_PIPELINE_LOG_DIALOG = 'View function log Dialog';

export const AVAILABLE_GRAINS_TABLE = 'AvailableGrainsTable';
export const ENTITY_TYPE_CONSTANTS_TABLE = 'EntityTypeConstantsTable';

export const DATAITEM_TYPE_METRIC = 'METRIC';
export const DATAITEM_TYPE_EVENT = 'EVENT';
export const DATAITEM_TYPE_DERIVED = 'DERIVED_METRIC';
export const DATAITEM_TYPE_CALCULATED_METRIC = 'CALCULATED_METRIC';
export const DATAITEM_TYPE_DIMENSION = 'DIMENSION';
export const DATAITEM_TYPE_DERIVED_DIMENSION = 'DERIVED_DIMENSION';
export const DATAITEM_TYPE_DERIVED_EVENT = 'DERIVED_EVENT';
export const DATAITEM_TYPE_DERIVED_ALERT = 'DERIVED_ALERT';

// TAGS
export const DATAITEM_TAG_COMPLEX = 'COMPLEX';
export const DATAITEM_TAG_DIMENSION = 'DIMENSION';
export const DATAITEM_TAG_ALERT = 'ALERT';
export const DATAITEM_TAG_EVENT = 'EVENT';

export const ENTITY_CONSTANT = 'entity_constant';
export const GLOBAL_CONSTANT = 'global_constant';

export const KPI_GRANULARITY_HOURLY = 'Hourly';
export const KPI_GRANULARITY_DAILY = 'Daily';
export const KPI_GRANULARITY_WEEKLY = 'Weekly';
export const KPI_GRANULARITY_MONTHLY = 'Monthly';
export const KPI_GRANULARITY_YEARLY = 'Yearly';

// KPI Category
export const KPI_CATEGORY_TRANSFORMER = 'TRANSFORMER';
export const KPI_CATEGORY_ALERT = 'ALERT';
export const KPI_CATEGORY_AGGREGATOR = 'AGGREGATOR';
export const KPI_CATEGORY_IMPORT_ENTITY_TYPE = 'IMPORT_ENTITY_TYPE';

export const AGGREGATE = 'AGGREGATE';

// Data Item constants
export const COLUMNTYPE_NUMBER = 'NUMBER';
export const COLUMNTYPE_TIMESTAMP = 'TIMESTAMP';
export const COLUMNTYPE_BOOLEAN = 'BOOLEAN';
export const COLUMNTYPE_LITERAL = 'LITERAL';
export const COLUMNTYPE_JSON = 'JSON';
export const COLUMNTYPE_ARRAY = 'ARRAY';

// Scope constants
export const SCOPE_FILTER_TYPES = {
  ALLENTITIES: 'ALLENTITIES',
  DIMENSIONS: 'DIMENSIONS', // legacy type
  CHILD_NODE: 'DIMENSIONS', // TODO: CHILD_NODE is the new type that is going replace DIMENSIONS. When the API starts supporting this new type, replace 'DIMENSIONS' value with 'CHILD_NODE' in this constant
  EXPRESSIONS: 'EXPRESSIONS',
};

// Dimensions Match filter options
export const DATA_ITEM_MATCH_FILTER_OPTIONS = {
  ALL: 'ALL',
  ANY: 'ANY',
};

// Input type
export const INPUT_TYPE_DATA_ITEM = 'DATA_ITEM';
export const INPUT_TYPE_CONSTANT = 'CONSTANT';
export const INPUT_TYPE_DOMAIN = 'DOMAIN';

// Dependency type
export const DEPENDENCY_TYPE_FUNCTION = 'FUNCTION';
export const DEPENDENCY_TYPE_GRANULARITY = 'GRANULARITY';

export const KPI_DEFAULT_TIME_RANGE = KPI_GRANULARITY_HOURLY;

export const FORM_FIELDS = {
  GRANULARITY_SELECTOR: 'granularity',
};

export const RESOURCE_TYPES = {
  ORGANIZATION: 'ORGANIZATION',
  SITE: 'SITE',
  SYSTEM: 'SYSTEM',
  LOCATION_TYPE: 'LOCATION_TYPE',
  LOCATION: 'LOCATION',
  ASSET_TYPE: 'ASSET_TYPE',
  ASSET: 'ASSET',
  DEVICE_TYPE: 'DEVICE_TYPE',
  DEVICE: 'DEVICE',
};

export const HIERARCHY_MAX_ITEMS_PER_PAGE = 7;

export const HIERARCHY_ITEM_STATUS = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
};

export const HIERARCHY_ITEM_ACTIONS = {
  VIEW_DETAILS: 'view_details',
  ARCHIVE: 'archive',
  OPEN_IN_MANAGE: 'openManage',
};

export const METRICS_DIALOGS = {
  ADD_METRICS_MODAL: 'ADD_METRICS_MODAL',
};
